import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files (you might have more languages or a different structure)
import enTranslation from './locales/en/translation.json';
import amTranslation from './locales/am.json'; // Import Amharic translation

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      am: {
        translation: amTranslation,
      },
    },
    lng: 'en', // default language
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
